import { useState, useEffect } from "react";
import classes from "./Careers.module.css";
import SearchResultsBottomSheet from "../../components/Search/MobileSearch/SearchResultsBottomSheet";

const Careers = () => {
  return <div className={classes.container}></div>;
};

export default Careers;
